import React from 'react';
import { LayoutChannelsWebProps } from './props';
import { AppBar } from '../../components/navbar/components';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useAuthContext } from '../../../contexts/authContext';
import Toolbar from '@mui/material/Toolbar';

export const LayoutChannelsWeb = ({ title }: LayoutChannelsWebProps) => {
    const { modeTheme } = useAuthContext();

    return (
        <>
            <AppBar position="fixed" open={false}>
                <Toolbar>
                    <Box
                        component="img"
                        src={
                            modeTheme === 'darkMode'
                                ? require('../../../assets/images/logos/previsora_black.png')
                                : require('../../../assets/images/logos/previsora.png')
                        }
                        sx={{
                            width: '120px',
                            height: '65px',
                        }}
                        alt="logo"
                    />
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{
                            flexGrow: 1,
                            ml: 1,
                            fontSize: { lg: 25, md: 21, xs: 12 },
                            letterSpacing: {
                                lg: '.3rem',
                                md: '.2rem',
                                xs: '.1rem',
                            },
                            textDecoration: 'none',
                            display: 'flex',
                        }}
                    >
                        {title}
                    </Typography>
                </Toolbar>
            </AppBar>
        </>
    );
};
